/* eslint-disable import/no-cycle */
import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { Button, Input } from 'ui/atoms';
import MainFont from 'ui/typography/mainFont';

import {
  AdvancedSearchContainer,
  ButtonContainer,
  Content,
  ErrorContainer,
  InputsContainer,
  SingleInputContainer
} from './style';

const AdvancedSearch = ({
  height,
  advancedSearchFields,
  advancedSearchValues,
  onSubmitAdvancedChange,
  onSubmitAdvancedSearch
}) => {
  const { t } = useTranslation();
  return (
    <AdvancedSearchContainer sectionHeight={height.toString()}>
      <MainFont type="accountPopupText">{t('advanced_search_lead')}</MainFont>
      <Content>
        <InputsContainer>
          {advancedSearchFields.map(input => (
            <SingleInputContainer key={input.name}>
              <Input
                status={input.error ? 'invalid' : ''}
                customWidth="304"
                variant="editaccountdata"
                placeholder={t(input.name)}
                type="text"
                value={advancedSearchValues[input.name]}
                onChange={e =>
                  onSubmitAdvancedChange(
                    e?.currentTarget?.value,
                    input.actionType
                  )
                }
                /*icon={
                <Icon
                  type="icon-close"
                  color={theme().colors.blue.one}
                  size={12}
                  onClick={() => onSubmitAdvancedChange('', input.actionType)}
                />
              }*/
              />
              <ErrorContainer>
                <MainFont type="errorLabel">{t(input.error)}</MainFont>
              </ErrorContainer>
            </SingleInputContainer>
          ))}
        </InputsContainer>
        <ButtonContainer>
          <Button
            variant="accept-button"
            onClick={onSubmitAdvancedSearch}
            disabled={advancedSearchFields.find(obj => obj.error)}
          >
            {t('proceed')}
          </Button>
        </ButtonContainer>
      </Content>
    </AdvancedSearchContainer>
  );
};

AdvancedSearch.propTypes = {
  height: PropTypes.number,
  advancedSearchFields: PropTypes.array,
  onSubmitAdvancedSearch: PropTypes.func,
  advancedSearchValues: PropTypes.object,
  onSubmitAdvancedChange: PropTypes.func
};

export default connect(null, null)(AdvancedSearch);
